export const ssoParam = {
  refreshToken: 'refresh_token',
  clientId: 'client_id',
  redirectUri: 'redirect_uri',
  responseType: 'response_type',
  scope: 'scope',
  grantType: 'grant_type',
  code: 'code',
  fallbackUri: 'fallback_uri',
  state: 'state',
  prompt: 'prompt'
};

export const authTokenParam = {
  grantType: 'grantType',
  grantValue: 'grantValue',
  redirectUri: 'redirectUri',
};
